"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Html5SupportedFormats = exports.buildCodecMimeTypes = void 0;
var player_base_1 = require("@24i/player-base");
function buildCodecMimeTypes(codec) {
    switch (codec) {
        case player_base_1.VIDEO_CODEC.AV1:
            return [player_base_1.MIME_TYPE.MP4_VIDEO + "; codecs=\"av01.0.01M.08\""];
        case player_base_1.VIDEO_CODEC.VP8:
            return [player_base_1.MIME_TYPE.MP4_VIDEO + "; codecs=\"vp8\""];
        case player_base_1.VIDEO_CODEC.VP9:
            return [
                player_base_1.MIME_TYPE.MP4_VIDEO + "; codecs=\"vp9\"",
                player_base_1.MIME_TYPE.MP4_VIDEO + "; codecs=\"vp09.00.10.08\"",
                player_base_1.MIME_TYPE.WEBM_VIDEO + "; codecs=\"vp9\"",
                player_base_1.MIME_TYPE.WEBM_VIDEO + "; codecs=\"vp09.00.10.08\"",
            ];
        case player_base_1.VIDEO_CODEC.H264:
            return [
                player_base_1.MIME_TYPE.MP4_VIDEO + "; codecs=\"avc1.42E01E\"",
                player_base_1.MIME_TYPE.MP4_VIDEO + "; codecs=\"avc3.42E01E\"",
                player_base_1.MIME_TYPE.MP4_VIDEO + "; codecs=\"avc3\"",
                player_base_1.MIME_TYPE.MPEG_VIDEO + "; codecs=\"avc1.42E01E\"",
                player_base_1.MIME_TYPE.MPEG_VIDEO + "; codecs=\"avc3.42E01E\"",
            ];
        case player_base_1.VIDEO_CODEC.H265:
            return [
                player_base_1.MIME_TYPE.MP4_VIDEO + "; codecs=\"hev1.1.6.L93.90\"",
                player_base_1.MIME_TYPE.MP4_VIDEO + "; codecs=\"hvc1.1.6.L93.90\"",
                player_base_1.MIME_TYPE.MP4_VIDEO + "; codecs=\"hev1.2.4.L153.B0\"; eotf=\"smpte2084\"",
                player_base_1.MIME_TYPE.MP4_VIDEO + "; codecs=\"hvc1.2.4.L153.B0\"; eotf=\"smpte2084\"",
                player_base_1.MIME_TYPE.MPEG_VIDEO + "; codecs=\"hvc1.1.6.L93.90\"",
            ];
        case player_base_1.AUDIO_CODEC.AAC:
            return [
                player_base_1.MIME_TYPE.MP4_AUDIO + "; codecs=\"mp4a.40.2\"",
                player_base_1.MIME_TYPE.MP4_AUDIO + "; codecs=\"mp4a.40.5\"",
                player_base_1.MIME_TYPE.MP4_AUDIO + "; codecs=\"mp4a.40.29\"",
            ];
        case player_base_1.AUDIO_CODEC.AC3:
            return [player_base_1.MIME_TYPE.MP4_AUDIO + "; codecs=\"ac-3\""];
        case player_base_1.AUDIO_CODEC.EAC3:
            return [player_base_1.MIME_TYPE.MP4_AUDIO + "; codecs=\"ec-3\""];
        case player_base_1.AUDIO_CODEC.OPUS:
            return [player_base_1.MIME_TYPE.MP4_AUDIO + "; codecs=\"opus\""];
        case player_base_1.AUDIO_CODEC.VORBIS:
            return [player_base_1.MIME_TYPE.MP4_AUDIO + "; codecs=\"vorbis\""];
        case player_base_1.AUDIO_CODEC.FLAC:
            return [player_base_1.MIME_TYPE.MP4_AUDIO + "; codecs=\"flac\""];
        case player_base_1.TEXT_CODEC.VTT:
            return ['text/vtt', 'application/mp4; codecs="wvtt"'];
        case player_base_1.TEXT_CODEC.SRT:
            return ['text/srt'];
        case player_base_1.TEXT_CODEC.TTML:
            return ['application/ttml+xml', 'application/mp4; codecs="stpp"'];
        default:
            return [];
    }
}
exports.buildCodecMimeTypes = buildCodecMimeTypes;
var Html5SupportedFormats = (function (_super) {
    __extends(Html5SupportedFormats, _super);
    function Html5SupportedFormats() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Html5SupportedFormats.prototype.isTypeSupported = function (mimeType) {
        if ('MediaSource' in window) {
            return MediaSource.isTypeSupported(mimeType);
        }
        return false;
    };
    Html5SupportedFormats.prototype.initialize = function () {
        return __awaiter(this, void 0, void 0, function () {
            var screenHeight, mediaElement, _a, _b, _c, _d, _e, _f, _g, _h;
            var _this = this;
            return __generator(this, function (_j) {
                switch (_j.label) {
                    case 0:
                        screenHeight = window.screen.height;
                        mediaElement = document.createElement('video');
                        this.manifest = [];
                        if (!this.checkManifest(player_base_1.MIME_TYPE.DASH, mediaElement)) return [3, 2];
                        _b = (_a = this.manifest).push;
                        return [4, player_base_1.registerDash(screenHeight, function (c) { return _this.checkCodec(c, mediaElement); }, function () { return _this.detectWidevine(); }, function () { return _this.detectPlayReady(); }, false)];
                    case 1:
                        _b.apply(_a, [_j.sent()]);
                        _j.label = 2;
                    case 2:
                        if (!this.checkManifest(player_base_1.MIME_TYPE.SMOOTH_STREAM, mediaElement)) return [3, 4];
                        _d = (_c = this.manifest).push;
                        return [4, player_base_1.registerSmoothStreaming(screenHeight, function (c) { return _this.checkCodec(c, mediaElement); }, function () { return _this.detectWidevine(); }, function () { return _this.detectPlayReady(); }, false)];
                    case 3:
                        _d.apply(_c, [_j.sent()]);
                        _j.label = 4;
                    case 4:
                        if (!this.checkManifest(player_base_1.MIME_TYPE.HLS, mediaElement)) return [3, 6];
                        _f = (_e = this.manifest).push;
                        return [4, player_base_1.registerHls(screenHeight, function (c) { return _this.checkCodec(c, mediaElement); }, function () { return _this.detectFairPlay(); }, false)];
                    case 5:
                        _f.apply(_e, [_j.sent()]);
                        _j.label = 6;
                    case 6:
                        if (!this.checkNative()) return [3, 8];
                        _h = (_g = this.manifest).push;
                        return [4, player_base_1.registerNative(screenHeight, function (f) { return _this.checkType(f, mediaElement); }, function (c) { return _this.checkCodec(c, mediaElement); }, false)];
                    case 7:
                        _h.apply(_g, [_j.sent()]);
                        _j.label = 8;
                    case 8: return [4, _super.prototype.initialize.call(this)];
                    case 9:
                        _j.sent();
                        return [2];
                }
            });
        });
    };
    Html5SupportedFormats.prototype.checkNative = function () {
        return true;
    };
    Html5SupportedFormats.prototype.checkManifest = function (mimeType, mediaElement) {
        if (this.isTypeSupported(mimeType))
            return true;
        if (mediaElement && mediaElement.canPlayType(mimeType) !== '')
            return true;
        return false;
    };
    Html5SupportedFormats.prototype.checkType = function (mimeType, mediaElement) {
        if (this.isTypeSupported(mimeType))
            return true;
        if (mediaElement && mediaElement.canPlayType(mimeType) !== '')
            return true;
        return false;
    };
    Html5SupportedFormats.prototype.checkCodec = function (codec, mediaElement) {
        var _this = this;
        return buildCodecMimeTypes(codec).some(function (mime) {
            return _this.checkType(mime, mediaElement);
        });
    };
    Html5SupportedFormats.prototype.detectWidevine = function () {
        var _this = this;
        return this.checkDRMKeySystems([player_base_1.DRM_TYPE.WIDEVINE], function (keySystems, offline) { return ({
            name: player_base_1.DRM_NAME.WIDEVINE,
            keySystems: keySystems,
            offline: offline,
            providers: _this.getWidevineProviders(),
        }); });
    };
    Html5SupportedFormats.prototype.getWidevineProviders = function () {
        return [];
    };
    Html5SupportedFormats.prototype.detectPlayReady = function () {
        var _this = this;
        return this.checkDRMKeySystems([player_base_1.DRM_TYPE.PLAYREADY], function (keySystems, offline) { return ({
            name: player_base_1.DRM_NAME.PLAYREADY,
            keySystems: keySystems,
            offline: offline,
            providers: _this.getPlayReadyProviders(),
        }); });
    };
    Html5SupportedFormats.prototype.getPlayReadyProviders = function () {
        return [];
    };
    Html5SupportedFormats.prototype.detectFairPlay = function () {
        var _this = this;
        return this.checkDRMKeySystems([
            player_base_1.DRM_TYPE.FAIRPLAY,
            player_base_1.DRM_TYPE.FAIRPLAY_1,
            player_base_1.DRM_TYPE.FAIRPLAY_2,
            player_base_1.DRM_TYPE.FAIRPLAY_3,
        ], function (keySystems, offline) { return ({
            name: player_base_1.DRM_NAME.FAIRPLAY,
            keySystems: keySystems,
            offline: offline,
            providers: _this.getFairPlayProviders(),
        }); });
    };
    Html5SupportedFormats.prototype.getFairPlayProviders = function () {
        return [];
    };
    Html5SupportedFormats.prototype.checkDRMKeySystems = function (keySystems, builder) {
        return __awaiter(this, void 0, void 0, function () {
            var checks, successful, supportedKeySystems, supportsOffline;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, Promise.all(keySystems.map(function (ks) { return _this.checkDRMKeySystem(ks); }))];
                    case 1:
                        checks = _a.sent();
                        successful = checks.filter(function (s) { return Boolean(s); });
                        if (successful.length === 0)
                            return [2, undefined];
                        supportedKeySystems = successful.map(function (s) { return s.keySystem; });
                        supportsOffline = successful.some(function (s) { return s.offline; });
                        return [2, builder(supportedKeySystems, supportsOffline)];
                }
            });
        });
    };
    Html5SupportedFormats.prototype.checkDRMKeySystem = function (keySystem) {
        return __awaiter(this, void 0, void 0, function () {
            var initDataTypes, videoCapabilities, onlineConfig, offlineConfig, access, sessionTypes, offline, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        initDataTypes = ['cenc'];
                        videoCapabilities = [
                            { contentType: player_base_1.MIME_TYPE.MP4_VIDEO + "; codecs=\"avc1.42E01E\"" },
                            { contentType: player_base_1.MIME_TYPE.WEBM_VIDEO + "; codecs=\"vp8\"" },
                        ];
                        onlineConfig = {
                            initDataTypes: initDataTypes,
                            videoCapabilities: videoCapabilities,
                        };
                        offlineConfig = {
                            videoCapabilities: videoCapabilities,
                            persistentState: 'required',
                            sessionTypes: ['persistent-license'],
                        };
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 4, , 5]);
                        return [4, navigator.requestMediaKeySystemAccess(keySystem, [offlineConfig, onlineConfig])];
                    case 2:
                        access = _a.sent();
                        sessionTypes = access.getConfiguration().sessionTypes;
                        offline = sessionTypes
                            ? sessionTypes.includes('persistent-license')
                            : false;
                        return [4, access.createMediaKeys()];
                    case 3:
                        _a.sent();
                        return [2, {
                                keySystem: keySystem,
                                offline: offline,
                            }];
                    case 4:
                        e_1 = _a.sent();
                        return [2, undefined];
                    case 5: return [2];
                }
            });
        });
    };
    return Html5SupportedFormats;
}(player_base_1.BaseSupportedFormats));
exports.Html5SupportedFormats = Html5SupportedFormats;
//# sourceMappingURL=index.js.map